<template>
  <Flex
    v-if="!showMobileMenu"
    align="center"
  >
    <Flex
      v-if="$screen === 'l'"
      :gap="0.5"
    >
      <BaseIcon
        :tooltip="{
            position: 'bottom',
            text: $t('global.actions.edit_customer')
          }"
        name="edit"
        @click="onCustomerAction('edit')"
        v-test="'customerEdit'"
      />
      <BaseIcon
        :tooltip="{
            position: 'bottom',
            text: $t('global.actions.delete_customer')
          }"
        name="archive"
        @click="onCustomerAction('delete')"
        v-test="'customerDelete'"
      />
      <BaseIcon
        :tooltip="{
            position: 'bottom',
            text: $t('global.actions.merge_customer')
          }"
        name="person-add"
        @click="onCustomerAction('merge')"
        v-test="'customerMerge'"
      />
    </Flex>

    <BaseMore
      v-else
      :options="['edit', 'delete', 'merge']"
      alignLeft
      @select="onCustomerAction"
      v-test="'customer-actions'"
    />
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { flash, modal } from '@/helpers/ui';
import { usePageLayoutStore } from '@/stores/page-layout';

const emit = defineEmits(['merge']);
const { showMobileMenu } = usePageLayoutStore();

const router = useRouter();
const customer = inject<any>('customer');

const { mutate: deleteCustomer } = useMutation(gql`
  mutation deleteCustomer($input: DeleteCustomerInput!) {
    deleteCustomer(input: $input) {
      customer {
        id
      }
    }
  }
`);

const { t } = useI18n();

const onCustomerAction = (action: string) => {
  switch (action) {
    case 'edit':
      router.push({
        name: 'customers-edit',
        params: { customerId: customer.value.id },
      });
      break;
    case 'delete':
      {
        modal('confirmation', {
          message: `${t('global.actions.archive_item', {
            item: customer.value.fullName,
          })}?`,
        }).then(() => {
          deleteCustomer({
            input: {
              id: customer.value.id,
            },
          }).then(() => {
            router.push({ name: 'customers' });
            flash(t('global.flash.customer_deleted'));
          });
        });
      }
      break;
    case 'merge':
      emit('merge');
      break;
  }
};
</script>
